import { render, staticRenderFns } from "./MessageBodyNode.vue?vue&type=template&id=0a03ab92&scoped=true&lang=pug&"
import script from "./MessageBodyNode.vue?vue&type=script&lang=js&"
export * from "./MessageBodyNode.vue?vue&type=script&lang=js&"
import style0 from "./MessageBodyNode.vue?vue&type=style&index=0&id=0a03ab92&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a03ab92",
  null
  
)

component.options.__file = "MessageBodyNode.vue"
export default component.exports